import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/sections/$sectionId/')({
  beforeLoad: () => {
    // TODO: Implement it - https://panowie.atlassian.net/browse/RG-247
    throw redirect({
      replace: true,
      to: '/'
    })
  }
})
